export const bar = {
    background: "#FFF",
}